import { useCallback } from 'react';
import { useMutation } from 'react-query';
import { testPrinter as testPrinterReq } from 'data/requests/testPrinter';
import { useSnackbar } from 'notistack';
import {
  Variables,
  ResponseStatus,
  updateGeneralSetting,
} from 'data/requests/updateGeneralSettings';
import { CDError } from 'utils/error';

const useSettingsActions = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync: testPrinterMut, isLoading: testPrinterLoading } =
    useMutation<ResponseStatus, CDError>(testPrinterReq);

  const {
    mutateAsync: generalSettingsMutation,
    isLoading: loadingUpdateGeneralSetting,
  } = useMutation<ResponseStatus, CDError, Variables>(updateGeneralSetting);

  const updateGeneral = useCallback(
    async ({ printerCopies }: Variables) => {
      const response = await generalSettingsMutation({
        printerCopies,
      });

      return response;
    },
    [generalSettingsMutation],
  );

  const testPrinter = useCallback(async () => {
    const response = await testPrinterMut();

    enqueueSnackbar(`Printer tested`, {
      variant: 'success',
    });

    return response;
  }, [testPrinterMut, enqueueSnackbar]);

  return {
    testPrinter,
    testPrinterLoading,
    loadingUpdateGeneralSetting,
    updateGeneral,
  };
};

export default useSettingsActions;
